const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: 'https://ahfuforpmp.github.io',
  title: 'JS.',
}

const about = {
  // all the properties are optional - can be left empty or deleted
  name: 'ahfu168',
  role: 'An Indie Developer & AI Product Builder',
  picture: 'https://github.githubassets.com/assets/GitHub-Mark-ea2971cee799.png',

  description:
    'I build AI-powered apps and interactive experiences across web and mobile — from AI music and virtual characters to creative tools and consumer products.\n\nI enjoy turning ideas into real products, exploring new technologies, and creating simple, useful, and engaging experiences for people around the world.',
  resume: '',
  social: {
    x: '',
    instagram: '',
    youtube: '',
  },
}

const projects = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  {
    name: 'MiraYola: AI Music Maker',
    description:
      'An AI music maker and exploration space (formerly Song Flow). Turn your ideas into original songs, remixes and music videos in minutes - no production skills needed.',
    stack: ['AI Music', 'Remix', 'Music Video'],
    social: {
      link: 'https://mirayola.huoji.app/',
      x: 'https://x.com/MiraYolaJ5l/',
      instagram: 'https://www.instagram.com/mirayola.j5l/',
      youtube: 'https://www.youtube.com/@mirayola-j5l',
      googlePlay: 'https://play.google.com/store/apps/details?id=com.huoji.singflow',
      appleStore: 'https://apps.apple.com/app/id6763990335',
    },
    image: 'mira-yola.png',
  },
  {
    name: 'My Singing Pet: AI Pet Video',
    description:
      'Turn your pet photo into a fun, expressive talking or singing video with AI in just one tap. Record your voice, upload audio, use TTS or AI song clips, then share on TikTok and Instagram.',
    stack: ['AI Video', 'TTS', 'Animation'],
    social: {
      link: '',
      x: '',
      instagram: '',
      youtube: '',
      googlePlay: 'https://play.google.com/store/apps/details?id=com.huoji.mysingingpet',
      appleStore: '',
    },
    image: 'my-singing-pet.png',
  },
  {
    name: 'Listenix - Podcasts & AI Reader',
    description:
      'A podcast player and AI reader in one app: discover podcasts, listen to radio stations from over 100 countries, and turn TXT and EPUB files into natural-sounding AI narration.',
    stack: ['Podcasts', 'Radio', 'AI TTS'],
    social: {
      link: '',
      x: '',
      instagram: '',
      youtube: '',
      googlePlay: 'https://play.google.com/store/apps/details?id=com.huoji.podcasts',
      appleStore: 'https://apps.apple.com/app/id6754307298',
    },
    image: 'listenix.png',
  },
  {
    name: 'AI Art & Video - Vibe Imagine',
    description:
      'An all-in-one AI art, image and short video generator. Create AI images, anime avatars, illustrations and 10-second AI videos with one tap - no design skills required.',
    stack: ['AI Art', 'AI Image', 'AI Video'],
    social: {
      link: '',
      x: '',
      instagram: '',
      youtube: '',
      googlePlay: 'https://play.google.com/store/apps/details?id=com.huoji.vibeimage',
      appleStore: 'https://apps.apple.com/app/id6752362749',
    },
    image: 'vibe-imagine.png',
  },
  {
    name: 'Petnori: Virtual Pet Companion',
    description:
      'Adopt cute virtual cats and dogs, feed, pet, brush and play with them every day. A relaxed virtual pet companion with expressive animations and no pressure.',
    stack: ['Virtual Pet', 'Companion'],
    social: {
      link: 'https://hipet.huoji.app/',
      x: '',
      instagram: '',
      youtube: '',
      googlePlay: 'https://play.google.com/store/apps/details?id=com.huoji.hipet',
      appleStore: 'https://apps.apple.com/app/id6776550745',
    },
    image: 'hi-pet.png',
  },
  {
    name: 'AudioBook Maker and Player',
    description:
      'Convert EPUB and TXT books into audio files chapter by chapter, with natural voices in multiple languages, offline listening and a built-in EPUB reader.',
    stack: ['Audiobook', 'TTS', 'EPUB/TXT'],
    social: {
      link: '',
      x: '',
      instagram: '',
      youtube: '',
      googlePlay: 'https://play.google.com/store/apps/details?id=com.huoji.audiobook',
      appleStore: 'https://apps.apple.com/app/id6462842842',
    },
    image: 'audiobook-maker.png',
  },
  {
    name: 'Piano Go',
    description:
      'A realistic piano simulator for phone and tablet. Play Grand Piano, Vintage Piano, Electric Piano, Organ, Guitar and more with ultra-realistic sounds.',
    stack: ['Piano', 'Music', 'Simulator'],
    social: {
      link: '',
      x: '',
      instagram: '',
      youtube: '',
      googlePlay: 'https://play.google.com/store/apps/details?id=com.huoji.midi.pianomidi',
      appleStore: 'https://apps.apple.com/app/id6443826823',
    },
    image: 'piano-go.png',
  },
]

const skills = [
  'Flutter',
  'React',
  'Next.js',
  'Node.js',
  'TypeScript',
  'Firebase',
  'AI Integration',
  'FFmpeg',
  'Mobile Apps',
  'Web Apps',
  'App Store & Google Play',
  'SEO',
  'Git',
]

const contact = {
  // email is optional - if left empty Contact section won't show up
  email: 'zhifudu@gmail.com',
}

export { header, about, projects, skills, contact }
